/**
 * Build-time variables the app cannot run without. Shared by the build-time
 * check in vite.config.ts and the runtime check in parseEnv.ts, so the two can
 * never disagree about what "configured" means.
 */
export const REQUIRED_ENV = [
  'VITE_API_BASE_URL',
  'VITE_AUTH_AUTHORITY',
  'VITE_AUTH_CLIENT_ID'
] as const;

export type RequiredEnvName = (typeof REQUIRED_ENV)[number];
